import Color from "color";

const convertToRgba = (colorInput, opacity) => {
    try {
        const col = Color(colorInput);
        return col.alpha(opacity).rgb().string();
    } catch (error) {
        console.error("Invalid color format:", colorInput);
        return `rgba(0, 0, 0, ${opacity})`;
    }
};

export default convertToRgba;
